import { dateFormatter } from '@/helpers/dateFormatter'
import { userNameInitials } from '@/helpers/nameFormatter'


export const initPlugin = ({ Vue }) => {
  Vue.filter('dateFormatter', dateFormatter)
  Vue.filter('userNameInitials', userNameInitials)
}
